import DropsOverview from '@aboutyou/legacy-shared/src/pages/Drops/Overview/DropsOverviewPage'
import DropsTranslationContext from '@aboutyou/legacy-shared/src/pages/Drops/context/TranslationProvider'
import { FullscreenLoading } from 'components/Loading'
import { useTrackingCustomer } from 'helpers/tracking/trackerComponents/TrackCustomer'
import { toJS } from 'mobx'
import { useDropTranslations } from 'pages/Drops/useDropTranslations'
import React from 'react'
import { useDropsOverviewPageStore } from 'store/context'

const DropsOverviewPage: React.FC = () => {
  const dropsOverViewPage = useDropsOverviewPageStore(
    store => store.dropsOverViewPage,
  )
  const dropsOverViewPageLoading = useDropsOverviewPageStore(
    store => store.dropsOverviewPageLoading,
  )

  const translations = useDropTranslations()
  const trackingCustomer = useTrackingCustomer()

  if (dropsOverViewPage === null || dropsOverViewPageLoading) {
    // TODO - can the drop overview from grips be null always ?
    return <FullscreenLoading />
  }

  return (
    <DropsTranslationContext.Provider value={translations}>
      <DropsOverview
        dropsOverviewPage={toJS(dropsOverViewPage.data)}
        trackingCustomer={trackingCustomer}
      />
    </DropsTranslationContext.Provider>
  )
}

export default DropsOverviewPage
